/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClientValue } from './clientValue';

export interface ClientBlacklistResponse {
  isBlacklisted?: boolean;
  value?: Array<ClientValue>;
}
